// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatarEditor_scaleRange {
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 15px;
    width: 6px;
    /*height: 100%;*/
    background: #ccc;
    appearance: none;
    -webkit-appearance: none;
    writing-mode: sideways-lr;
}

/* Thumb: webkit */
.avatarEditor_scaleRange::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none; 
    height: 15px;
    width: 15px;
    background-color: #fa0;
    border-radius: 50%;
    border: none;
    transition: .2s ease-in-out;
}

/* Thumb: Firefox */
.avatarEditor_scaleRange::-moz-range-thumb {
    height: 15px;
    width: 15px;
    background-color: #fa0;
    border-radius: 50%;
    border: none;
    transition: .2s ease-in-out;
}

/* Hover, active & focus Thumb: Webkit */

.avatarEditor_scaleRange::-webkit-slider-thumb:hover {
    box-shadow: 0 0 0 4px rgba(255,85,0, .1)
}

.avatarEditor_scaleRange:active::-webkit-slider-thumb {
    box-shadow: 0 0 0 5px rgba(255,85,0, .2)
}

.avatarEditor_scaleRange:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 5px rgba(255,85,0, .2)
}

/* Hover, active & focus Thumb: Firfox */

.avatarEditor_scaleRange::-moz-range-thumb:hover {
    box-shadow: 0 0 0 10px rgba(255,85,0, .1)
}

.avatarEditor_scaleRange:active::-moz-range-thumb {
    box-shadow: 0 0 0 13px rgba(255,85,0, .2)
}

.avatarEditor_scaleRange:focus::-moz-range-thumb {
    box-shadow: 0 0 0 13px rgba(255,85,0, .2)    
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/addClient/AvatarEditorBlockRange.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA,wCAAwC;;AAExC;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,wCAAwC;;AAExC;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".avatarEditor_scaleRange {\n    width: 100%;\n    cursor: pointer;\n    outline: none;\n    border-radius: 15px;\n    width: 6px;\n    /*height: 100%;*/\n    background: #ccc;\n    appearance: none;\n    -webkit-appearance: none;\n    writing-mode: sideways-lr;\n}\n\n/* Thumb: webkit */\n.avatarEditor_scaleRange::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none; \n    height: 15px;\n    width: 15px;\n    background-color: #fa0;\n    border-radius: 50%;\n    border: none;\n    transition: .2s ease-in-out;\n}\n\n/* Thumb: Firefox */\n.avatarEditor_scaleRange::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    background-color: #fa0;\n    border-radius: 50%;\n    border: none;\n    transition: .2s ease-in-out;\n}\n\n/* Hover, active & focus Thumb: Webkit */\n\n.avatarEditor_scaleRange::-webkit-slider-thumb:hover {\n    box-shadow: 0 0 0 4px rgba(255,85,0, .1)\n}\n\n.avatarEditor_scaleRange:active::-webkit-slider-thumb {\n    box-shadow: 0 0 0 5px rgba(255,85,0, .2)\n}\n\n.avatarEditor_scaleRange:focus::-webkit-slider-thumb {\n    box-shadow: 0 0 0 5px rgba(255,85,0, .2)\n}\n\n/* Hover, active & focus Thumb: Firfox */\n\n.avatarEditor_scaleRange::-moz-range-thumb:hover {\n    box-shadow: 0 0 0 10px rgba(255,85,0, .1)\n}\n\n.avatarEditor_scaleRange:active::-moz-range-thumb {\n    box-shadow: 0 0 0 13px rgba(255,85,0, .2)\n}\n\n.avatarEditor_scaleRange:focus::-moz-range-thumb {\n    box-shadow: 0 0 0 13px rgba(255,85,0, .2)    \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
